// extracted by mini-css-extract-plugin
export default {"container":"gallery-unavailable-page_container__C6YkS"};